(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["megasmuth"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('smuth-megahome-v2')){customElements.define('smuth-megahome-v2',class extends HTMLElement{
 connectedCallback(){if(this._cleanup)this._cleanup();const controller=new AbortController(),signal=controller.signal;const video=this.querySelector('video'),gate=this.querySelector('dialog'),enter=this.querySelector('[data-enter]'),play=this.querySelector('[data-play]'),sound=this.querySelector('[data-sound]');const motion=matchMedia('(prefers-reduced-motion: reduce)');let userPaused=false,visible=false,opening=false,timer=null;const sessionKey='smuth-entered-v2';
 const mute=()=>{video.muted=true;sound.textContent='Activar sonido';sound.setAttribute('aria-pressed','false')};const pause=()=>{video.pause();mute()};
 const start=()=>{document.querySelectorAll('smuth-megahome-v2 video').forEach(other=>{if(other!==video){other.pause();other.muted=true;const otherSound=other.closest('smuth-megahome-v2').querySelector('[data-sound]');if(otherSound){otherSound.textContent='Activar sonido';otherSound.setAttribute('aria-pressed','false')}}});const result=video.play();if(result)result.catch(()=>{})};
 const automatic=()=>{if(visible&&!document.hidden&&!userPaused&&!motion.matches&&!video.hidden){mute();start()}else pause()};
 const entered=()=>{try{return sessionStorage.getItem(sessionKey)==='yes'}catch(e){return this.constructor.entered===true}};
 const openSite=(animate=true)=>{if(opening||!gate.open)return;opening=true;try{sessionStorage.setItem(sessionKey,'yes')}catch(e){}this.constructor.entered=true;const finish=()=>{gate.close();if(this.constructor.gateOwner===this)this.constructor.gateOwner=null;gate.classList.remove('sm2-opening');opening=false;this.querySelector('.sm2-header nav a').focus({preventScroll:true})};if(animate&&!motion.matches){gate.classList.add('sm2-opening');timer=setTimeout(finish,650)}else finish()};
 this._cleanup=()=>{controller.abort();if(this._observer)this._observer.disconnect();if(this._menuObserver)this._menuObserver.disconnect();clearTimeout(timer);gate.classList.remove('sm2-opening');if(gate.open)gate.close();if(this.constructor.gateOwner===this)this.constructor.gateOwner=null;pause()};
 enter.addEventListener('click',()=>openSite(),{signal});gate.addEventListener('cancel',event=>{event.preventDefault();openSite(false)},{signal});
 const editor=this.dataset.editor==='true'||Boolean(window.Shopify&&Shopify.designMode);if(this.dataset.curtain==='true'&&!editor&&!entered()&&!this.constructor.entered&&!this.constructor.gateOwner){this.constructor.gateOwner=this;gate.showModal();enter.focus({preventScroll:true})}
 video.muted=true;video.addEventListener('play',()=>{play.textContent='Pausar';play.setAttribute('aria-label','Pausar video')},{signal});video.addEventListener('pause',()=>{mute();play.textContent='Reproducir';play.setAttribute('aria-label','Reproducir video')},{signal});video.addEventListener('error',()=>{video.hidden=true;pause();play.hidden=true;sound.hidden=true},{signal});play.addEventListener('click',()=>{if(video.paused){userPaused=false;start()}else{userPaused=true;video.pause()}},{signal});sound.addEventListener('click',()=>{video.muted=!video.muted;sound.setAttribute('aria-pressed',String(!video.muted));sound.textContent=video.muted?'Activar sonido':'Silenciar';if(!video.muted&&video.paused){userPaused=false;start()}},{signal});
 this._observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{visible=entry.isIntersecting;automatic()})},{threshold:.2});this._observer.observe(video);const menu=this.querySelector('.sm2-menu-wrap'),dock=this.querySelector('.sm2-order-dock');if(menu&&dock){this._menuObserver=new IntersectionObserver(entries=>{entries.forEach(e=>dock.hidden=!e.isIntersecting)},{threshold:0});this._menuObserver.observe(menu);}motion.addEventListener('change',automatic,{signal});document.addEventListener('visibilitychange',automatic,{signal});document.addEventListener('shopify:section:unload',event=>{if(event.target===this||event.target.contains(this))this._cleanup()},{signal});this.addEventListener('shopify:block:select',()=>openSite(false),{signal});
 }disconnectedCallback(){if(this._cleanup)this._cleanup()}
})}


if (!customElements.get('smuth-mega-menu-v2')) {
  customElements.define('smuth-mega-menu-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.ui = JSON.parse(this.querySelector('[data-i18n]').textContent);
      this.products = new Map(Array.from(this.querySelectorAll('[data-product-json]'), node => {
        const product = JSON.parse(node.textContent);
        return [product.id, product];
      }));
      this.money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.reduceMotion = this.motionQuery.matches;
      this.motionQuery.addEventListener('change', event => { this.reduceMotion = event.matches; }, { signal: this.signal });
      this.dialog = this.querySelector('[data-product-dialog]');
      this.query = this.querySelector('[data-query]');
      this.query.addEventListener('input', () => this.search(), { signal: this.signal });
      this.querySelector('[data-clear-query]').addEventListener('click', () => this.resetSearch(), { signal: this.signal });
      this.querySelector('[data-reset]').addEventListener('click', () => this.resetSearch(), { signal: this.signal });
      this.querySelector('[data-search-toggle]').addEventListener('click', () => {
        this.querySelector('.sq-search-area').scrollIntoView({ behavior: this.reduceMotion ? 'instant' : 'smooth', block: 'center' });
        this.query.focus({ preventScroll: true });
      }, { signal: this.signal });
      this.addEventListener('click', event => {
        const open = event.target.closest('[data-open]');
        if (open) this.showProduct(open.dataset.open);
        if (event.target.closest('[data-close]')) this.closeDialog();
        const category = event.target.closest('[data-category-link]');
        if (category) {
          event.preventDefault();
          this.query.value = '';
          this.search();
          this.querySelector('[data-group="' + category.dataset.categoryLink + '"]').scrollIntoView({ behavior: this.reduceMotion ? 'instant' : 'smooth', block: 'start' });
          this.setActiveCategory(category.dataset.categoryLink);
        }
      }, { signal: this.signal });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.closeDialog(); }, { signal: this.signal });
      this.dialog.addEventListener('close', () => this.unlockScroll(), { signal: this.signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.closeDialog();
      }, { signal: this.signal });
      this.querySelectorAll('[data-photo-holder] img').forEach(img => {
        const fallback = () => {
          const holder = img.closest('[data-photo-holder]');
          if (!holder || holder.querySelector('.sq-photo-type')) return;
          holder.classList.add('sq-no-photo');
          const product = this.products.get(img.closest('[data-card]').dataset.card);
          img.remove();
          holder.prepend(this.photoType(product));
        };
        img.addEventListener('error', fallback, { signal: this.signal });
        if (img.complete && !img.naturalWidth) fallback();
      });
      window.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.updateActiveCategory(); });
      }, { passive: true, signal: this.signal });
      document.addEventListener('shopify:section:unload', event => { if(event.target === this || event.target.contains(this)) this.disconnectedCallback(); }, { signal: this.signal });
      this.addEventListener('shopify:block:select', event => { const card = event.target.closest('[data-card]'); if(card){ this.query.value=''; this.search(); card.scrollIntoView({block:'center'}); } }, {signal:this.signal});
      this.search();
      this.ready = true;
    }
    disconnectedCallback() {
      this.closeDialog();
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      this.ready = false;
    }
    node(tag, className = '', text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }
    photoType(product) {
      const type = this.node('span', 'sq-photo-type');
      type.append(this.node('span', '', 'Smüth'), this.node('b', '', product.name));
      return type;
    }
    showProduct(id) {
      const product = this.products.get(id);
      if (!product) return;
      document.querySelectorAll('smuth-mega-menu-v2').forEach(other => { if(other!==this) other.closeDialog(); });
      this.querySelector('[data-detail-name]').textContent = product.name;
      this.querySelector('[data-detail-category]').textContent = this.ui[product.category.toLowerCase()];
      this.querySelector('[data-detail-price]').textContent = this.money.format(product.price);
      this.querySelector('[data-detail-description]').textContent = product.description;
      const photo = this.querySelector('[data-detail-photo]');
      photo.replaceChildren();
      if (product.photo) {
        const background = this.node('img', 'sq-detail-background');
        background.src = product.photo;
        background.alt = '';
        background.setAttribute('aria-hidden', 'true');
        const image = this.node('img', 'sq-detail-foreground');
        image.src = product.photo;
        image.alt = product.name;
        image.width = 720;
        image.height = 960;
        image.addEventListener('error', () => photo.replaceChildren(this.photoType(product)), { once: true });
        photo.append(background, image);
      } else photo.append(this.photoType(product));
      if (this.previousOverflow === undefined) {
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      if (!this.dialog.open) this.dialog.showModal();
      this.dialog.scrollTop = 0;
    }
    closeDialog() {
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
    }
    unlockScroll() {
      if (this.dialog?.open || this.previousOverflow === undefined) return;
      document.body.style.overflow = this.previousOverflow;
      this.previousOverflow = undefined;
    }
    resetSearch() {
      this.query.value = '';
      this.search();
      this.query.focus();
    }
    search() {
      const normalize = value => value.toLocaleLowerCase('es').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const query = normalize(this.query.value.trim());
      const words = query.split(/\s+/).filter(Boolean);
      let count = 0;
      this.querySelectorAll('[data-card]').forEach(card => {
        const text = normalize(card.dataset.name + ' ' + card.dataset.description);
        card.hidden = !words.every(word => text.includes(word));
        if (!card.hidden) count++;
      });
      this.querySelectorAll('[data-group]').forEach(group => {
        const visible = Array.from(group.querySelectorAll('[data-card]')).filter(card => !card.hidden).length;
        group.hidden = !visible;
        const link = this.querySelector('.sq-category[data-category-link="' + group.dataset.group + '"]');
        link.querySelector('sup').textContent = String(visible).padStart(2, '0');
        group.querySelector('.sq-section-note').textContent = visible + (visible === 1 ? ' opción' : ' opciones');
      });
      const status = this.querySelector('[data-search-status]');
      status.hidden = !query;
      status.textContent = this.ui.results.replace('{count}', String(count));
      this.querySelector('[data-empty]').hidden = !!count;
      this.querySelector('[data-clear-query]').hidden = !query;
      this.updateActiveCategory();
    }
    updateActiveCategory() {
      const groups = Array.from(this.querySelectorAll('[data-group]')).filter(group => !group.hidden);
      let active = groups[0];
      for (const group of groups) if (group.getBoundingClientRect().top < 125) active = group;
      this.setActiveCategory(active?.dataset.group);
    }
    setActiveCategory(category) {
      this.querySelectorAll('.sq-category[data-category-link]').forEach(link => {
        const active = link.dataset.categoryLink === category;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menuqr"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('smuth-qr-v4')) {
  customElements.define('smuth-qr-v4', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.ui = JSON.parse(this.querySelector('[data-i18n]').textContent);
      this.products = new Map(Array.from(this.querySelectorAll('[data-product-json]'), node => {
        const product = JSON.parse(node.textContent);
        return [product.id, product];
      }));
      this.money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });
      this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.dialog = this.querySelector('[data-product-dialog]');
      this.query = this.querySelector('[data-query]');
      this.query.addEventListener('input', () => this.search(), { signal: this.signal });
      this.querySelector('[data-clear-query]').addEventListener('click', () => this.resetSearch(), { signal: this.signal });
      this.querySelector('[data-reset]').addEventListener('click', () => this.resetSearch(), { signal: this.signal });
      this.querySelector('[data-search-toggle]').addEventListener('click', () => {
        this.querySelector('.sq-search-area').scrollIntoView({ behavior: this.reduceMotion ? 'instant' : 'smooth', block: 'center' });
        this.query.focus({ preventScroll: true });
      }, { signal: this.signal });
      this.addEventListener('click', event => {
        const open = event.target.closest('[data-open]');
        if (open) this.showProduct(open.dataset.open);
        if (event.target.closest('[data-close]')) this.closeDialog();
        const category = event.target.closest('[data-category-link]');
        if (category) {
          event.preventDefault();
          this.query.value = '';
          this.search();
          this.querySelector('[data-group="' + category.dataset.categoryLink + '"]').scrollIntoView({ behavior: this.reduceMotion ? 'instant' : 'smooth', block: 'start' });
          this.setActiveCategory(category.dataset.categoryLink);
        }
      }, { signal: this.signal });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.closeDialog(); }, { signal: this.signal });
      this.dialog.addEventListener('close', () => this.unlockScroll(), { signal: this.signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.closeDialog();
      }, { signal: this.signal });
      this.querySelectorAll('[data-photo-holder] img').forEach(img => {
        const fallback = () => {
          const holder = img.closest('[data-photo-holder]');
          if (!holder || holder.querySelector('.sq-photo-type')) return;
          holder.classList.add('sq-no-photo');
          const product = this.products.get(img.closest('[data-card]').dataset.card);
          img.remove();
          holder.prepend(this.photoType(product));
        };
        img.addEventListener('error', fallback, { signal: this.signal });
        if (img.complete && !img.naturalWidth) fallback();
      });
      window.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.updateActiveCategory(); });
      }, { passive: true, signal: this.signal });
      this.search();
      this.ready = true;
    }
    disconnectedCallback() {
      this.closeDialog();
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      this.ready = false;
    }
    node(tag, className = '', text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }
    photoType(product) {
      const type = this.node('span', 'sq-photo-type');
      type.append(this.node('span', '', 'Smüth'), this.node('b', '', product.name));
      return type;
    }
    showProduct(id) {
      const product = this.products.get(id);
      if (!product) return;
      this.querySelector('[data-detail-name]').textContent = product.name;
      this.querySelector('[data-detail-category]').textContent = this.ui[product.category.toLowerCase()];
      this.querySelector('[data-detail-price]').textContent = this.money.format(product.price);
      this.querySelector('[data-detail-description]').textContent = product.description;
      const photo = this.querySelector('[data-detail-photo]');
      photo.replaceChildren();
      if (product.photo) {
        const background = this.node('img', 'sq-detail-background');
        background.src = product.photo;
        background.alt = '';
        background.setAttribute('aria-hidden', 'true');
        const image = this.node('img', 'sq-detail-foreground');
        image.src = product.photo;
        image.alt = product.name;
        image.width = 720;
        image.height = 960;
        image.addEventListener('error', () => photo.replaceChildren(this.photoType(product)), { once: true });
        photo.append(background, image);
      } else photo.append(this.photoType(product));
      if (this.previousOverflow === undefined) {
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      if (!this.dialog.open) this.dialog.showModal();
      this.dialog.scrollTop = 0;
    }
    closeDialog() {
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
    }
    unlockScroll() {
      if (this.dialog?.open || this.previousOverflow === undefined) return;
      document.body.style.overflow = this.previousOverflow;
      this.previousOverflow = undefined;
    }
    resetSearch() {
      this.query.value = '';
      this.search();
      this.query.focus();
    }
    search() {
      const normalize = value => value.toLocaleLowerCase('es').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const query = normalize(this.query.value.trim());
      const words = query.split(/\s+/).filter(Boolean);
      let count = 0;
      this.querySelectorAll('[data-card]').forEach(card => {
        const text = normalize(card.dataset.name + ' ' + card.dataset.description);
        card.hidden = !words.every(word => text.includes(word));
        if (!card.hidden) count++;
      });
      this.querySelectorAll('[data-group]').forEach(group => {
        const visible = Array.from(group.querySelectorAll('[data-card]')).filter(card => !card.hidden).length;
        group.hidden = !visible;
        const link = this.querySelector('.sq-category[data-category-link="' + group.dataset.group + '"]');
        link.querySelector('sup').textContent = String(visible).padStart(2, '0');
        group.querySelector('.sq-section-note').textContent = visible + (visible === 1 ? ' opción' : ' opciones');
      });
      const status = this.querySelector('[data-search-status]');
      status.hidden = !query;
      status.textContent = this.ui.results.replace('{count}', String(count));
      this.querySelector('[data-empty]').hidden = !!count;
      this.querySelector('[data-clear-query]').hidden = !query;
      this.updateActiveCategory();
    }
    updateActiveCategory() {
      const groups = Array.from(this.querySelectorAll('[data-group]')).filter(group => !group.hidden);
      let active = groups[0];
      for (const group of groups) if (group.getBoundingClientRect().top < 125) active = group;
      this.setActiveCategory(active?.dataset.group);
    }
    setActiveCategory(category) {
      this.querySelectorAll('.sq-category[data-category-link]').forEach(link => {
        const active = link.dataset.categoryLink === category;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pantalla"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('smuth-screen')) {
  class SmuthScreen extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.signal = this.abort.signal;
      this.index = 0;
      this.paused = this.dataset.autoplay !== 'true' || this.dataset.editor === 'true';
      this.defaultDuration = Math.max(6, Number(this.dataset.duration) || 12) * 1000;
      this.remaining = this.defaultDuration;
      this.timer = null;
      this.idleTimer = null;
      this.mediaTimer = null;
      this.lastVisibilityPause = false;
      this.started = false;
      this.stage = this.querySelector('[data-stage]');
      try {
        this.products = JSON.parse(this.querySelector('[data-products]').textContent);
        this.reels = JSON.parse(this.querySelector('[data-reels]').textContent);
      } catch (error) {
        this.querySelector('[data-loader]').classList.add('is-done');
        return;
      }
      this.byId = Object.fromEntries(this.products.map(p => [p.id, p]));
      this.scenes = [];
      this.renderScenes();
      this.progress = this.querySelector('[data-progress]');
      this.toggleButton = this.querySelector('[data-toggle]');
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), { signal: this.signal });
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1), { signal: this.signal });
      this.toggleButton.addEventListener('click', () => this.setPaused(!this.paused), { signal: this.signal });
      this.querySelector('[data-fullscreen]').addEventListener('click', () => this.fullscreen(), { signal: this.signal });
      this.addEventListener('pointermove', () => this.wakeControls(), { signal: this.signal });
      this.addEventListener('pointerdown', event => {
        this.wakeControls();
        if (!event.target.closest('a,button,input,select,textarea')) this.focus({ preventScroll: true });
      }, { signal: this.signal });
      this.addEventListener('focusin', () => this.wakeControls(), { signal: this.signal });
      this.addEventListener('keydown', event => {
        if (event.target.matches('input,textarea,select') || event.ctrlKey || event.metaKey || event.altKey) return;
        this.wakeControls();
        if (event.code === 'Space' && !event.target.closest('button,a')) { event.preventDefault(); this.setPaused(!this.paused); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index - 1); }
        if (event.key.toLowerCase() === 'f') { event.preventDefault(); this.fullscreen(); }
      }, { signal: this.signal });
      document.addEventListener('fullscreenchange', () => {
        const button = this.querySelector('[data-fullscreen]');
        const active = document.fullscreenElement === this;
        button.textContent = active ? 'Salir de pantalla completa ↙' : 'Pantalla completa ↗';
        button.setAttribute('aria-label', active ? 'Salir de pantalla completa' : 'Entrar en pantalla completa');
      }, { signal: this.signal });
      document.addEventListener('visibilitychange', () => {
        if (!this.started) return;
        if (document.hidden && !this.paused) { this.lastVisibilityPause = true; this.setPaused(true); }
        else if (!document.hidden && this.lastVisibilityPause) { this.lastVisibilityPause = false; this.setPaused(false); }
      }, { signal: this.signal });
      document.addEventListener('shopify:block:select', event => {
        if (event.detail?.sectionId !== this.dataset.section) return;
        this.setPaused(true);
        const block = [...this.querySelectorAll('[data-block-id]')].find(el => el.dataset.blockId === event.detail.blockId);
        if (block) {
          const index = this.scenes.findIndex(scene => [...scene.querySelectorAll('[data-product]'), scene].some(el => el.dataset.product === block.dataset.code));
          if (index >= 0) this.show(index);
        }
        this.wakeControls();
      }, { signal: this.signal });
      this.updateToggle();
      this.show(0, true);
      this.preload().finally(() => {
        if (this.signal.aborted) return;
        this.started = true;
        this.querySelector('[data-loader]').classList.add('is-done');
        this.activateMedia();
        this.arm(this.durationFor(this.activeScene));
        this.wakeControls();
        this.ready = true;
      });
    }

    disconnectedCallback() {
      this.abort?.abort();
      window.clearTimeout(this.timer);
      window.clearTimeout(this.idleTimer);
      window.clearTimeout(this.mediaTimer);
      window.clearTimeout(this.preloadTimeout);
      this.querySelectorAll('video').forEach(v => v.pause());
      this.querySelectorAll('.tv-scene').forEach(s => s.remove());
      this.initialized = false;
    }

    el(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }

    photo(src, alt, className = '') {
      const holder = this.el('figure', 'tv-photo ' + className);
      if (src) {
        const img = this.el('img');
        img.width = 1200;
        img.height = 1600;
        img.alt = alt;
        img.decoding = 'async';
        img.loading = 'eager';
        img.dataset.src = src;
        img.addEventListener('error', () => holder.classList.add('is-unavailable'), { signal: this.signal });
        holder.append(img);
      } else holder.classList.add('is-unavailable');
      return holder;
    }

    kicker(text) { return this.el('p', 'tv-kicker', text); }
    price(product) { return this.el('span', 'tv-price', '$' + product.price); }

    scene(name, label, duration) {
      const scene = this.el('section', 'tv-scene tv-scene--' + name);
      scene.dataset.label = label;
      scene.dataset.duration = duration || this.defaultDuration;
      scene.setAttribute('aria-label', label);
      scene.setAttribute('aria-hidden', 'true');
      scene.inert = true;
      this.stage.append(scene);
      this.scenes.push(scene);
      return scene;
    }

    heading(title, kicker, note) {
      const head = this.el('div', 'tv-section-head');
      const copy = this.el('div');
      copy.append(this.kicker(kicker), this.el('h2', 'tv-serif', title));
      head.append(copy);
      if (note) head.append(this.el('p', '', note));
      return head;
    }

    menuScene(products, number, label) {
      const scene = this.scene('menu', label, Math.max(this.defaultDuration, 15000));
      scene.append(this.heading('Smoothies.', '14 maneras de encontrar tu mood · ' + number + ' / 02', 'Fruta, mezclas que se antojan y tu próximo favorito.'));
      const grid = this.el('div', 'tv-menu-grid');
      products.forEach(product => {
        const card = this.el('article', 'tv-menu-card');
        card.dataset.product = product.id;
        if (product.photo) card.append(this.photo(product.photo, product.name));
        else card.append(this.el('span', 'tv-type-image', 'S'));
        const copy = this.el('div');
        copy.append(this.el('h3', '', product.name), this.el('p', '', product.description));
        card.append(copy, this.price(product));
        grid.append(card);
      });
      const note = this.el('p', 'tv-menu-note', number === '01' ? 'Tu día sabe mejor así.' : '¿Cuál es tu mood de hoy?');
      note.append(this.el('span', '', 'ESCANEA EL QR PARA VER EL MENÚ COMPLETO →'));
      grid.append(note);
      scene.append(grid);
    }

    hero(id, name, kicker, stamp) {
      const product = this.byId[id];
      const scene = this.scene('hero', product.name);
      scene.classList.add('tv-scene--' + name);
      scene.dataset.product = product.id;
      const copy = this.el('div', 'tv-hero-copy');
      copy.append(this.kicker(kicker), this.el('h2', 'tv-serif', product.name), this.el('p', '', product.description), this.price(product));
      const art = this.el('div', 'tv-hero-art');
      art.append(this.photo(product.photo, product.name), this.el('span', 'tv-stamp', stamp));
      scene.append(copy, art, this.el('span', 'tv-hero-serial', 'SMÜTH / ' + product.id));
    }

    reelScene(index, headline, emphasis, description, picks, poster) {
      const scene = this.scene('reel', 'SMÜTH EN MOVIMIENTO · ' + (index + 1), 25000);
      scene.dataset.reel = index;
      const frame = this.el('div', 'tv-reel-frame');
      frame.append(this.photo(poster, 'Smüth · bowls y smoothies'));
      const video = this.el('video');
      video.preload = 'auto';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('disablepictureinpicture', '');
      video.setAttribute('aria-label', 'Reel de Smüth ' + (index + 1));
      video.dataset.src = this.reels[index].src;
      video.addEventListener('playing', () => {
        frame.classList.add('is-playing');
        if (this.activeScene === scene && !this.paused && this.started) this.arm(this.durationFor(scene));
      }, { signal: this.signal });
      video.addEventListener('error', () => {
        frame.classList.remove('is-playing');
        frame.classList.add('is-unavailable');
        if (this.activeScene === scene && this.started && !this.paused) this.arm(8000);
      }, { signal: this.signal });
      video.addEventListener('ended', () => {
        if (this.activeScene === scene && !this.paused) this.show(this.index + 1);
      }, { signal: this.signal });
      frame.append(video, this.el('span', 'tv-reel-tag', 'SMÜTH / REEL 0' + (index + 1)));
      const copy = this.el('div', 'tv-reel-copy');
      const title = this.el('h2', 'tv-serif', headline + ' ');
      title.append(this.el('em', '', emphasis));
      copy.append(this.kicker('El mood se prepara aquí.'), title, this.el('p', '', description));
      const cards = this.el('div', 'tv-reel-picks');
      picks.forEach(id => {
        const p = this.byId[id];
        const card = this.el('article');
        card.dataset.product = p.id;
        card.append(this.photo(p.photo, p.name), this.el('h3', '', p.name), this.price(p));
        cards.append(card);
      });
      copy.append(cards);
      scene.append(frame, copy, this.el('span', 'tv-reel-number', 'BOWLS & SMOOTHIE BAR'));
    }

    renderScenes() {
      const intro = this.scene('intro', 'SMÜTH IS THE MOOD.', 9000);
      const introCopy = this.el('div', 'tv-intro-copy');
      const title = this.el('h1', 'tv-serif', 'smüth is ');
      title.append(this.el('em', '', 'the mood.'));
      introCopy.append(this.kicker('BOWLS & SMOOTHIE BAR'), title, this.el('p', '', 'Smoothies, bowls y algo rico para acompañar. Elige tu mood.'));
      const introArt = this.el('div', 'tv-intro-art');
      introArt.append(this.photo('https://lh3.googleusercontent.com/d/12E_iDnoYkbV3SCJijOqCZS8zKBs6Hqkn=w1600', 'Smoothies Smüth preparados al momento'), this.el('span', 'tv-stamp', 'GOOD FOOD.\nGOOD MOOD.'));
      intro.append(introCopy, introArt);
      const smoothies = this.products.filter(p => p.category === 'SMOOTHIES');
      this.menuScene(smoothies.slice(0, 7), '01', 'SMOOTHIES · 01 / 02');
      this.reelScene(0, 'Una pausa.', 'Mucho mood.', 'Date una vuelta por Smüth y encuentra algo rico para tu día.', ['S01','S12','B02'], 'https://lh3.googleusercontent.com/d/11f54m-4Ld7nv0OPnfoXJ5HK3RZ3jSNFP=w1000');
      this.menuScene(smoothies.slice(7), '02', 'SMOOTHIES · 02 / 02');
      this.hero('S09', 'banana', 'Sabe a escape tropical.', 'PIÑA + COCO\n+ BLUE MOOD');
      const bowls = this.scene('bowls', 'BOWLS · LOS CINCO FAVORITOS', Math.max(this.defaultDuration, 14000));
      const head = this.heading('Bowl mood.', 'BLOOM / PLAYA / BLISS / MALIBÚ / ALOHA');
      const bowlProducts = this.products.filter(p => p.category === 'BOWLS');
      const uniformPrice = bowlProducts.every(p => p.price === bowlProducts[0].price);
      const headPrice = this.el('p', 'tv-head-price', uniformPrice ? '$' + bowlProducts[0].price : 'Desde $' + Math.min(...bowlProducts.map(p => p.price)));
      headPrice.append(this.el('small', '', 'INCLUYEN HASTA 2 FRUTAS + 3 TOPPINGS'));
      head.append(headPrice);
      bowls.append(head);
      const bowlGrid = this.el('div', 'tv-bowl-grid');
      bowlProducts.forEach(p => {
        const card = this.el('article', 'tv-bowl-card');
        card.dataset.product = p.id;
        card.append(this.photo(p.photo, p.name), this.el('h3', '', p.name), this.el('p', '', p.description));
        if (!uniformPrice) card.append(this.price(p));
        bowlGrid.append(card);
      });
      bowls.append(bowlGrid);
      this.reelScene(1, 'Cucharada de', 'good mood.', 'Tu combinación de fruta, yogurt y toppings, preparada al momento.', ['B01','B03','B05'], 'https://lh3.googleusercontent.com/d/1NlIZ6yAFgl6KhT7H1X78hcrdGOiqsgTk=w1200');
      const food = this.scene('food', 'COMIDA · TAMBIÉN SE ANTOJA', Math.max(this.defaultDuration, 14000));
      food.append(this.heading('Y algo para comer.', 'ACOMPAÑA TU MOOD', 'Dulce, fresco o con ese toque picosito.'));
      const foodGrid = this.el('div', 'tv-food-grid');
      this.products.filter(p => p.category === 'COMIDA').forEach(p => {
        const card = this.el('article', 'tv-food-card');
        card.dataset.product = p.id;
        const name = this.el('div', 'tv-food-title');
        name.append(this.el('h3', '', p.name), this.price(p));
        card.append(this.photo(p.photo, p.name), name, this.el('p', '', p.description));
        foodGrid.append(card);
      });
      food.append(foodGrid);
      this.hero('S05', 'jamaiquini', 'Fresa. Frambuesa. Jamaica.', 'BERRY\nGOOD MOOD');
      const extras = this.scene('extras', 'EXTRAS · HAZLO A TU MODO');
      const extrasCopy = this.el('div', 'tv-extras-copy');
      extrasCopy.append(this.kicker('Un extra de lo que te gusta.'), this.el('h2', 'tv-serif', 'Hazlo a tu modo.'));
      const extraList = this.el('dl', 'tv-extras-list');
      [['Proteína',35],['Leche vegetal',10],['Topping extra',10],['Fruta extra',10],['Creatina',15]].forEach(([name,price]) => {
        const row = this.el('div', 'tv-extra-row');
        row.append(this.el('dt', '', name), this.el('dd', '', '+$' + price));
        extraList.append(row);
      });
      extrasCopy.append(extraList);
      extras.append(extrasCopy, this.photo('https://lh3.googleusercontent.com/d/1YFeEKGHmPerpFgKK3OhO2YNXLFNSe-Ei=w1400', 'Bowl de Smüth con fruta y toppings', 'tv-extras-photo'));
      this.reelScene(2, 'Tu próxima', 'buena pausa.', 'Smoothies, bowls y antojos. Pide el que se te antoje y disfruta el momento.', ['C03','C04','S10'], 'https://lh3.googleusercontent.com/d/1-sEvtDycgrRWVXDj-ULOF95qnnco4KF2=w1000');
      const outro = this.scene('outro', 'EL MOOD SE QUEDA CONTIGO.', 8000);
      const outroTitle = this.el('h2', 'tv-serif tv-outro-title', 'good food. ');
      outroTitle.append(this.el('em', '', 'good mood.'));
      const bottom = this.el('div', 'tv-outro-bottom');
      bottom.append(this.el('p', '', 'Preparado al momento.\nDisfrutado a tu manera.'), this.el('p', '', 'Elige desde tu cel. →'));
      outro.append(this.kicker('SMÜTH / BOWLS & SMOOTHIE BAR'), outroTitle, bottom, this.el('span', 'tv-outro-star', '✳'));
    }

    async preload() {
      const unique = new Map();
      this.querySelectorAll('img[data-src]').forEach(img => {
        if (!unique.has(img.dataset.src)) unique.set(img.dataset.src, []);
        unique.get(img.dataset.src).push(img);
      });
      const videos = [...this.querySelectorAll('video')];
      const total = unique.size + videos.length;
      let done = 0;
      const update = () => {
        done++;
        const ratio = Math.min(1, done / total);
        this.querySelector('[data-load-progress]').style.transform = 'scaleX(' + ratio + ')';
        this.querySelector('[data-load-label]').textContent = 'Fotos y reels · ' + Math.round(ratio * 100) + '%';
      };
      const workers = [...unique.entries()].map(async ([src, images]) => {
        await new Promise(resolve => {
          const first = images[0];
          const finish = () => {
            first.removeEventListener('load', finish);
            first.removeEventListener('error', finish);
            resolve();
          };
          first.addEventListener('load', finish, { once: true });
          first.addEventListener('error', finish, { once: true });
          images.forEach(img => { img.src = src; });
          if (first.complete) finish();
        });
        update();
      });
      videos.forEach(video => {
        workers.push(new Promise(resolve => {
          const finish = () => {
            video.removeEventListener('loadeddata', finish);
            video.removeEventListener('error', finish);
            update();
            resolve();
          };
          video.addEventListener('loadeddata', finish, { once: true });
          video.addEventListener('error', finish, { once: true });
          video.src = video.dataset.src;
          video.load();
        }));
      });
      await Promise.race([Promise.allSettled(workers), new Promise(resolve => { this.preloadTimeout = window.setTimeout(resolve, 10000); })]);
      window.clearTimeout(this.preloadTimeout);
    }

    get activeScene() { return this.scenes[this.index]; }

    durationFor(scene) {
      const video = scene?.querySelector('video');
      if (video && Number.isFinite(video.duration) && video.duration > 0) {
        return Math.min(90000, Math.max(8000, (video.duration - video.currentTime + .6) * 1000));
      }
      return Number(scene?.dataset.duration) || this.defaultDuration;
    }

    arm(duration) {
      window.clearTimeout(this.timer);
      this.remaining = duration;
      this.progress.style.transition = 'none';
      this.progress.style.transform = 'scaleX(0)';
      if (this.paused || !this.started) return;
      this.startedAt = performance.now();
      void this.progress.offsetWidth;
      this.progress.style.transition = 'transform ' + duration + 'ms linear';
      this.progress.style.transform = 'scaleX(1)';
      this.timer = window.setTimeout(() => this.show(this.index + 1), duration);
    }

    show(next, initial = false) {
      if (!this.scenes.length) return;
      const old = this.activeScene;
      const normalized = (next % this.scenes.length + this.scenes.length) % this.scenes.length;
      window.clearTimeout(this.timer);
      window.clearTimeout(this.mediaTimer);
      this.scenes.forEach((scene, i) => {
        scene.classList.toggle('is-leaving', !initial && scene === old && i !== normalized);
        scene.classList.toggle('is-active', i === normalized);
        scene.setAttribute('aria-hidden', String(i !== normalized));
        scene.inert = i !== normalized;
        const video = scene.querySelector('video');
        if (video) {
          video.pause();
          try { video.currentTime = 0; } catch (error) {}
          scene.querySelector('.tv-reel-frame').classList.remove('is-playing');
        }
      });
      this.index = normalized;
      this.remaining = this.durationFor(this.activeScene);
      this.querySelector('[data-counter]').textContent = String(normalized + 1).padStart(2, '0') + ' / ' + String(this.scenes.length).padStart(2, '0');
      this.querySelector('[data-scene-label]').textContent = this.activeScene.dataset.label;
      if (this.started) {
        this.activateMedia();
        this.arm(this.durationFor(this.activeScene));
      }
    }

    activateMedia() {
      const video = this.activeScene.querySelector('video');
      if (!video || this.paused) return;
      const frame = video.closest('.tv-reel-frame');
      if (frame.classList.contains('is-unavailable')) return;
      video.muted = true;
      video.play().catch(() => {
        frame.classList.remove('is-playing');
        if (this.activeScene.contains(video) && !this.paused) this.arm(8000);
      });
      const atStart = video.currentTime;
      this.mediaTimer = window.setTimeout(() => {
        if (this.activeScene.contains(video) && !this.paused && video.currentTime <= atStart + .15) {
          frame.classList.remove('is-playing');
          video.pause();
          this.arm(6000);
        }
      }, 8000);
    }

    setPaused(paused) {
      if (this.paused === paused) return;
      this.paused = paused;
      if (paused) {
        this.remaining = Math.max(100, this.remaining - (performance.now() - (this.startedAt || performance.now())));
        window.clearTimeout(this.timer);
        window.clearTimeout(this.mediaTimer);
        const transform = getComputedStyle(this.progress).transform;
        this.progress.style.transition = 'none';
        this.progress.style.transform = transform;
        this.activeScene.querySelector('video')?.pause();
      } else {
        this.activateMedia();
        this.arm(this.activeScene.querySelector('video') ? this.durationFor(this.activeScene) : this.remaining);
      }
      this.updateToggle();
    }

    updateToggle() {
      this.toggleButton.textContent = this.paused ? 'Reproducir' : 'Pausar';
      this.toggleButton.setAttribute('aria-label', this.paused ? 'Reproducir pantalla' : 'Pausar pantalla');
      this.toggleButton.setAttribute('aria-pressed', String(this.paused));
    }

    wakeControls() {
      window.clearTimeout(this.idleTimer);
      this.classList.remove('is-idle');
      this.classList.add('is-controls-visible');
      this.idleTimer = window.setTimeout(() => {
        this.classList.remove('is-controls-visible');
        if (!this.querySelector('.tv-controls').contains(document.activeElement)) this.classList.add('is-idle');
      }, 3500);
    }

    async fullscreen() {
      try {
        if (document.fullscreenElement === this) await document.exitFullscreen();
        else if (this.requestFullscreen) await this.requestFullscreen({ navigationUI: 'hide' });
        else if (this.webkitRequestFullscreen) this.webkitRequestFullscreen();
        this.focus({ preventScroll: true });
      } catch (error) { this.wakeControls(); }
    }
  }
  customElements.define('smuth-screen', SmuthScreen);
}


  } catch(e) { console.error(e); }
})();
})();
